import { render, staticRenderFns } from "./RoomAvailUpdate.vue?vue&type=template&id=afc2e6e4"
import script from "./RoomAvailUpdate.vue?vue&type=script&lang=js"
export * from "./RoomAvailUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports